import * as Yup from 'yup';
const createValidationScheme = (form_settings) => {
    const valdationInputEntries = Object.values(form_settings.input_types.items).map((item) => {
        let validation = null
        if (['text', 'textfield', 'phone'].includes(item.form_layout_field_type)) {
            if (item.form_layout_field_mandatory) {
                validation = Yup.string().required("Feld wird benötigt")
            } else {
                validation = Yup.string()
            }
        }
        else if (item.form_layout_field_type === 'email') {
            if (item.form_layout_field_mandatory) {
                validation = Yup.string().email("Ungültige E-Mail").required("Feld wird benötigt")
            } else {
                validation = Yup.string().email("Ungültige E-Mail")
            }
        } else {
            validation = Yup.string()
        }
        return [item.form_layout_field_id, validation]
    })
    return Yup.object().shape({ input_types: Yup.object().shape(Object.fromEntries(valdationInputEntries)) })
}
export default createValidationScheme